(function(){
  'use strict';

  var KEY='pmy_phone_country';

  function fallbackCountry(){
    var lang=String(document.documentElement.lang||'').toLowerCase();
    return lang==='pt-br' ? 'BR' : 'PT';
  }

  function wantedCountry(){
    try{
      var saved=localStorage.getItem(KEY);
      if(saved) return String(saved).toUpperCase();
    }catch(e){}
    return fallbackCountry();
  }

  function persist(code){
    if(!code) return;
    try{localStorage.setItem(KEY,String(code).toUpperCase());}catch(e){}
  }

  function choose(trigger,code){
    if(!trigger || trigger.dataset.pmyUiV2!=='1' || trigger.dataset.pmyCountryBootstrapped==='1') return false;
    trigger.click();
    var options=document.querySelectorAll('.pmy-country-panel .pmy-select-option');
    var found=null;
    Array.prototype.some.call(options,function(option){
      var cc=option.querySelector('.pmy-country-code');
      if(cc && cc.textContent.trim().toUpperCase()===code){
        found=option;
        return true;
      }
      return false;
    });
    if(!found){
      if(trigger.getAttribute('aria-expanded')==='true') trigger.click();
      return false;
    }
    found.click();
    trigger.dataset.pmyCountryBootstrapped='1';
    return true;
  }

  function apply(){
    var trigger=document.getElementById('phone-prefix-trigger');
    if(trigger) choose(trigger,wantedCountry());
  }

  document.addEventListener('click',function(e){
    var opt=e.target.closest && e.target.closest('.pmy-country-panel .pmy-select-option');
    if(!opt) return;
    var cc=opt.querySelector('.pmy-country-code');
    if(cc) persist(cc.textContent);
  },true);

  function schedule(){
    setTimeout(apply,0);
    setTimeout(apply,120);
    setTimeout(apply,420);
  }
  function start(){
    schedule();
    window.addEventListener('pageshow',schedule);
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('[data-pmy-checkout-trigger]'))schedule();
    },true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
